module.exports = __webpack_public_path__ + "img/loyalty-voucher-title.9fb54e9e.svg";